import React from 'react';
import { Flex, Tag, Text } from '@chakra-ui/react';
import { getInvoiceStatusColor, getInvoiceStatusTranslation } from 'ts/common/common';
import { useTranslate } from 'ts/common/hooks';

interface Props {
    headingRightContent?: React.ReactNode;
    invoice: SpApi.Client.IInvoice;
}

const ClientInvoiceHeading = ({ headingRightContent, invoice }: Props) => {
    const t = useTranslate('clientInvoice');

    return (
        <Flex justifyContent="space-between" alignItems="flex-start" mb={10}>
            <Flex flexWrap="wrap" gap="16px" alignItems="center">
                <Text fontSize="20px" fontWeight="600" as="h1">
                    {t('headingText', {
                        customInvoiceId: invoice.customInvoiceId
                    })}
                </Text>
                <Tag
                    bg={getInvoiceStatusColor(invoice.invoiceStatus)}
                    fontWeight="500"
                    color="white"
                    textTransform="capitalize"
                >
                    {getInvoiceStatusTranslation(t, invoice.invoiceStatus)}
                </Tag>
            </Flex>
            {headingRightContent}
        </Flex>
    );
};

export default ClientInvoiceHeading;
